import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.orange3};
  background: ${({ theme }) => theme.colors.orange1};
  margin-bottom: 16px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  color: ${({ theme }) => theme.colors.black9};
  flex: 1 0 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const Text = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
